import AttendanceShift from '@/api/attendance-shift'

import { baseState, baseMutations } from '@/store/mixins'
import moment from 'moment'

export const state = {
  ...baseState,
  weekDays: [],
  edit_data: {}
}

export const getters = {
  totalHour: (state, getters) => detail => {
    if (
      (detail.first_in && detail.first_out) ||
      (detail.second_in && detail.second_out)
    ) {
      return getters.calculateTime(
        detail.first_in,
        detail.first_out,
        detail.second_in,
        detail.second_out
      )
    }

    return 0
  },

  tConvert: () => time => {
    if (time === null || time === undefined) return null
    // Check correct time format and split into components
    time = time
      .toString()
      .match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time]

    if (time.length > 1) {
      // If time format correct
      time = time.slice(1) // Remove full string match value
      time[5] = +time[0] < 12 ? ' AM' : ' PM' // Set AM/PM
      time[0] = +time[0] % 12 || 12 // Adjust hours
    }
    return time.join('') // return adjusted time or original string
  },

  calculateTime: () => (firstStart, firstEnd, secondStart, secondEnd) => {
    var duration = ''
    var secondDuration = ''
    var totalDuration = ''
    var hours = ''
    var minutes = ''

    if (moment(firstStart, 'HH:mm a') > moment(firstEnd, 'HH:mm a')) {
      duration = moment.duration(
        moment(
          moment()
            .add(1, 'days')
            .format('YYYY-MM-D ') + firstEnd
        ).diff(moment().format('YYYY-MM-D ') + firstStart)
      )
    } else {
      duration = moment.duration(
        moment(firstEnd, 'HH:mm a').diff(moment(firstStart, 'HH:mm a'))
      )
    }
    if (moment(secondStart, 'HH:mm a') > moment(secondEnd, 'HH:mm a')) {
      secondDuration = moment.duration(
        moment(
          moment()
            .add(1, 'days')
            .format('YYYY-MM-D ') + secondEnd
        ).diff(moment().format('YYYY-MM-D ') + secondStart)
      )
    } else {
      secondDuration = moment.duration(
        moment(secondEnd, 'HH:mm a').diff(moment(secondStart, 'HH:mm a'))
      )
    }

    totalDuration = moment.duration(
      duration._milliseconds + secondDuration._milliseconds
    )
    hours = parseInt(totalDuration.asHours())
    minutes = parseInt(totalDuration.asMinutes()) - hours * 60
    return {
      value: hours + '.' + minutes,
      description: hours + ' hour and ' + minutes + ' minutes.'
    }
  }
}

export const mutations = {
  ...baseMutations,
  SET_WEEK_DAYS(state, data) {
    state.weekDays = data
  },
  SET_EDIT_DATA(state, data) {
    state.edit_data = data
  }
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search
      },
      attrubutes
    )
    return AttendanceShift.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },

  store(context, data) {
    return AttendanceShift.store(data)
  },

  update(context, { id, data }) {
    return AttendanceShift.update(id, data)
  },
  destroy(context, id) {
    return AttendanceShift.destroy(id)
  },

  async find(context, id) {
    if (_.isEmpty(context.state.edit_data)) {
      let response = await AttendanceShift.find(id)
      context.commit('SET_EDIT_DATA', response.data)
    }
  },

  async dataBeforeCreate(context) {
    if (!context.state.weekDays.length > 0) {
      let response = await AttendanceShift.getWeekDay()
      context.commit('SET_WEEK_DAYS', response)
    }
  }
}
